import { useAuth0 } from '@auth0/auth0-react';
import './Header.css'

export default function LogoutButton() {
    const { logout } = useAuth0();

    return (
        <button
          className= "nav-link"
          onClick={() =>
            logout({
                logoutParams: {
                    returnTo: window.location.origin,
                },
            })
          }
        >
          Logout
        </button>
    );
}